import { Injectable, signal } from '@angular/core';
import { TeamMember } from '@interfaces/code-team/team-member';

@Injectable({
  providedIn: 'root',
})
export class StaffService {
  teamMembers = signal<TeamMember[]>([]);

  setTeamMembers(teamMembers: TeamMember[]) {
    this.teamMembers.set(teamMembers);
  }
}
